<template>
  <overlay-modal ref="overlayModal" width="30%">
    <template v-slot:header>
      <h4 class="cursive">Modifica ricerca</h4>
    </template>
    <template>
      <div class="modal-change-search container">
        <div>
          <form>
            <div class="row mb-4">
              <div class="col-12">
                <div class="form-group">
                  <label for="andataId">Partenza il</label>
                  <custom-date-picker
                    id="partenzaId"
                    v-model="search.partenza"
                    :disabled-dates="disabledDates"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="passeggeriId">Passeggeri</label>
                  <camere-selector
                    ref="camereSelectorRef"
                    id="passeggeriId"
                    v-model="search.camere"
                  />
                </div>
              </div>
            </div>
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary orange"
                @click="onClick"
              >
                Conferma modifiche
              </button>
            </div>
          </form>
        </div>
      </div>
    </template>
  </overlay-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OverlayModal from "../../../../modals/OverlayModal";
import CustomDatePicker from "../../../common/CustomDatePicker";
import CamereSelector from "../../../common/CamereSelector";
import { toDateFromServer } from "../../../../../utils/formatter";
import { isSameDate } from "../../../../../utils/helper";

export default {
  name: "ModalChangeSearch",
  components: { CamereSelector, CustomDatePicker, OverlayModal },
  data() {
    return {
      search: this.getSearch(),
    };
  },
  computed: {
    list: function () {
      return this.getTypesAereoporti().map(function (item) {
        return { label: item.name, value: item.id };
      });
    },
    dates() {
      const list = this.getTourList();
      let dates = [];
      list.forEach((tour) => {
        const tourDates = tour.element.departuresDatePrice.map((item) => {
          return toDateFromServer(item.date.date);
        });
        dates = dates.concat(tourDates);
      });
      return dates;
    },
    disabledDates() {
      if (!this.dates) return [];
      return {
        customPredictor: (date) => {
          const hasDate = this.dates.some((item) => {
            return isSameDate(date, item);
          });
          return !hasDate;
        },
      };
    },
  },
  methods: {
    ...mapGetters(["getSearch", "getTourList"]),
    ...mapActions(["addSearch"]),
    open: function () {
      this.$refs.overlayModal.open();
    },
    close: function () {
      this.$refs.overlayModal.close();
    },
    onClick: function () {
      this.close();
      this.addSearch(this.search);
      this.$scrollTo("#app");
      this.$router.push("/tour-selection");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/tour-accompagnati/modals/ModalChangeSearch.vue